import React from 'react';

const ShowActions = () => (<div>ShowActions</div>);

export default ShowActions;
